module.exports = __webpack_public_path__ + "images/store_case_study/aisuta-pic1_4e9dfe44fddadba9e1c42810b453ea5f.png";